export default __webpack_public_path__ + "static/media/neblina.06cd32fc.gif";